import type { CSSProperties } from 'react';

interface AvatarAccent {
  start: string;
  end: string;
  shadow: string;
}

const AVATAR_ACCENTS: AvatarAccent[] = [
  { start: '#93e2fa', end: '#1690bf', shadow: 'rgba(22, 144, 191, 0.28)' },
  { start: '#7cdccf', end: '#2db39c', shadow: 'rgba(45, 179, 156, 0.26)' },
  { start: '#87c8ff', end: '#538fdd', shadow: 'rgba(83, 143, 221, 0.26)' },
  { start: '#e6c07b', end: '#bf8341', shadow: 'rgba(191, 131, 65, 0.24)' },
  { start: '#e5a08d', end: '#bc6b61', shadow: 'rgba(188, 107, 97, 0.24)' },
  { start: '#9fcabf', end: '#5d9082', shadow: 'rgba(93, 144, 130, 0.24)' },
];

function hashSeed(seed: string): number {
  let hash = 0;

  for (let index = 0; index < seed.length; index += 1) {
    hash = ((hash * 31) + seed.charCodeAt(index)) >>> 0;
  }

  return hash;
}

export function getAvatarAccentStyle(seed: string | null | undefined): CSSProperties {
  const normalizedSeed = seed?.trim().toLowerCase() || 'unknown';
  const accent = AVATAR_ACCENTS[hashSeed(normalizedSeed) % AVATAR_ACCENTS.length];
  const style = {} as CSSProperties;

  (style as Record<string, string>)['--avatar-accent-start'] = accent.start;
  (style as Record<string, string>)['--avatar-accent-end'] = accent.end;
  (style as Record<string, string>)['--avatar-accent-border'] = accent.end;
  (style as Record<string, string>)['--avatar-accent-shadow'] = accent.shadow;

  return style;
}
